export const PROVIDER_MENU_TOUR_ID = 'calling-provider-switching-onboarding-tour';
export const PROVIDER_MENU_BUTTON_HEIGHT = 64.4;
export const PROVIDER_MENU_HEIGHT = 135.5;
export const PROVIDER_MENU_WIDTH = 372;
export const PROVIDER_MENU_MAX_HEIGHT = 480;
export const PROVIDER_MENU_HEADER_HEIGHT = 44;
export const PROVIDER_MENU_SHADOW_BUFFER = 8;
export const PROVIDER_MENU_FOOTER_HEIGHT = 78;
export const PROVIDER_MENU_BODY_MAX_HEIGHT = PROVIDER_MENU_MAX_HEIGHT - PROVIDER_MENU_HEADER_HEIGHT - PROVIDER_MENU_SHADOW_BUFFER;